import { httpClient } from '../http/httpClient'
import { SupportCategoryEnum } from '@/app/utils/supportCategoryEnum'

export interface DocumentTransaction {
  _id: string
  contract: string
  type: string
  sellerName: string
  sellerCpf: string
  sellerPhone: string
  customerName: string
  customerCpf: string
  customerPhone: string
  updatedAt?: string
  documentsCount?: number
}

export interface SupportTransactionSummary {
  _id: string
  contract?: string
  type?: string
  status?: string
  updatedAt?: string
  documentsCount?: number
}

export interface SupportTeam {
  _id: string
  name: string
  code?: string
  membersCount?: number
  leaderName?: string
}

export interface SupportPersonResult {
  _id: string
  name: string
  cpf: string
  phone: string
  createdAt?: string
  profileImageUrl?: string
  teams?: SupportTeam[]
  teamsCount?: number
  transactionsCount?: number
  pendingTransactionsCount?: number
  documentsTransactionsCount?: number
  documentsCount?: number
}

export interface CreateSupportResponse {
  user: { _id: string; name: string; cpf?: string; profileImageUrl?: string }
  sellers: SupportPersonResult[]
  customers: SupportPersonResult[]
  transactions: [
    {
      _id: string
      contract: string
      type?: string
      status?: string
      sellerName: string
      sellerCpf: string
      sellerPhone: string
      customerName: string
      customerPhone: string
      customerCpf: string
    },
  ]
  teams?: SupportTeam[]
  documentsTransactions?: DocumentTransaction[]
  pagination?: SupportSearchPagination
}

export interface SupportSearchPagination {
  skip: number
  limit: number
  totals: {
    sellers: number
    customers: number
    transactions: number
    teams: number
    documentsTransactions: number
  }
}

export interface CreateSupportParams {
  search: string
  categories: SupportCategoryEnum[]
  documents?: boolean
  saveHistory?: boolean
  searchId?: string
  skip?: number
  limit?: number
}

export async function createSupport(supportData: CreateSupportParams) {
  const { data } = await httpClient.post<CreateSupportResponse>(
    '/support',
    supportData,
  )

  return data
}
